import React, { Component } from 'react';
import './RateBenefits.css';
import _ from 'lodash';
import WeightBenefitsTabs from './WeightBenefitsTabs/WeightBenefitsTabs';
import CreateWeightlModal from './CreateWeightlModal/CreateWeightlModal';
import { ContentLowPriority } from 'material-ui/svg-icons';
import { debug } from 'util';
import AbilityToCompeteError from './AbilityToCompeteError/AbilityToCompeteError';

class RateBenefits extends Component {
    constructor(props) {
        super(props);
        this.state = {
            goNextStep: false,
            tabs: [],
            competeData: [],
            competitorsGroupsData: [],
            benefitsData: [],
            countCCWT: [],
            totalScore: '',

        }
    }

    componentWillMount() {
        let customerSegmentData ={
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData ={
            projectId: this.props.projectId,
            type: 'compete'
        }
        let challengeData = {
            type : "challenge",
            projectId : this.props.projectId,
        }

        let competitorsData = {
            projectId: this.props.projectId,
            type: 'competitors'
        }

        this.props.getCompetitorsGroups(competitorsData);
        this.props.getCustomerSegment(customerSegmentData);
        this.props.getCompete(competeData);
        this.props.getChallengeStatements(challengeData);
        //this.props.getBenefits(benefitData);
    }

    onNextButtonClick = () => {

        let stepValidation;
        let dataArr = 0;
        this.state.competeData.map(item=>{
            dataArr = dataArr + +item.wt
        });

        let k = this.state.tabs.length

        let findZeroWt = this.state.competeData.find(r => r.wt === 0 || r.wt === '0');
        let findZeroCCArray = [];

        this.state.competeData.map(item=>{
            item.criticalCapacity.map(childItem=>{
                findZeroCCArray.push(childItem);
            })
        })

        let findZeroCC = findZeroCCArray.find(r => r.text === '');
        let findZeroCcWt = findZeroCCArray.find(r => r.ccWt === 0 || r.ccWt === '0');

        // if( !findZeroWt && !findZeroCC && !findZeroCcWt && (dataArr === 100 * k ) ){
        if( dataArr === 100 * k ){
            stepValidation = true;
        } else {
            stepValidation = false;
        }

        if(stepValidation){
            if( this.state.createdData ) {
                let body = {
                    projectId: this.props.projectId,
                    type: "compete",
                    status: 'finished',
                    dataBenefits: this.state.competeData
                }
                this.setState({ goNextStep : true })
                this.props.createAbilityOfCompete(body)
            }
            if( this.state.editedData ) {
                let body = {
                    id: this.props.compete.competeData.Items[0].id,
                    projectId: this.props.projectId,
                    type: "compete",
                    status: 'finished',
                    dataBenefits: this.state.competeData
                }

                this.setState({ goNextStep : true })
                this.props.editAbilityOfCompete(body);


                let competitorsBody = {
                    type : 'competitors',
                    id : this.props.compete.competitorsGroupsData.Items[0].id,
                    competitors : this.state.competitorsGroupsData,
                }
                this.props.editCompetitorsGroups(competitorsBody);


            }
        }else {
            this.abilityToCompeteErrorModal();
        }
    }

    abilityToCompeteErrorModal = () => {
        this.setState({  abilityToCompeteError : !this.state.abilityToCompeteError })
    }

    componentWillReceiveProps(nextProps) {

        if( nextProps.compete.competeData.Items && _.isEmpty(this.state.competeData) ){
            if (!nextProps.compete.competeFetching && !_.isEmpty(nextProps.compete.competeData.Items) && !_.isEmpty(nextProps.compete.customerSegmentData)) {
                let data = [];
                let tabs = [];
                let oldGroupId = null;

                nextProps.compete.competeData.Items[0].dataBenefits.map(item=>{
                    if(!item.criticalCapacity){
                        let criticalCapacity = [{
                            text: '',
                            ccWt: item.wt
                        }];
                        item.criticalCapacity = criticalCapacity
                    }
                    data.push(item)
                });

                let tabTitleArr = [];
                nextProps.compete.competeData.Items[0].dataBenefits.map(item=>{
                    let customerSegmentItem = nextProps.compete.customerSegmentData.find(r => r.groupId === item.groupId);

                    let segmentData = customerSegmentItem.segments.find(r => r.segmentId === item.segmentId);

                    tabs.push({
                        groupId: item.groupId,
                        groupName: customerSegmentItem.groupName,
                        segmentId: item.segmentId,
                        segmentName: segmentData.name
                    });

                    if(_.isEmpty(nextProps.compete.benefitsData) && (item.groupId !== oldGroupId)){
                        oldGroupId = item.groupId

                        let benefitData = {
                            projectId: this.props.projectId,
                            type : 'benefitsLadder',
                            groupId: item.groupId,
                        }
                        this.props.getBenefits(benefitData)
                    }

                });
                this.setState({
                    competeData : data,
                    editedData : true,
                    createdData : false,
                    tabs: _.uniqBy(tabs, v => [v.groupId, v.segmentId].join())
                }, () => {
                    this.totalScore();
                    this.segmentTotalScore();
                });
            }


            if( _.isEmpty(nextProps.compete.competeData.Items) && !this.state.createdData){
                this.setState({createdData : true, editedData: false })
            }
        }

        if( nextProps.compete.competitorsGroupsData.Count > 0 &&  nextProps.compete.competitorsGroupsData.Items[0] && nextProps.compete.competitorsGroupsData.Items[0].competitors && !_.isEmpty(nextProps.compete.competitorsGroupsData.Items[0].competitors) && _.isEmpty(this.state.competitorsGroupsData) ) {
            this.setState({
                competitorsGroupsData: nextProps.compete.competitorsGroupsData.Items[0].competitors
            })
        }

        if(nextProps.compete.benefitsData && !_.isEmpty(nextProps.compete.benefitsData) &&  _.isEmpty(this.state.benefitsData)){
            this.setState({
                benefitsData: nextProps.compete.benefitsData
            })
        }

        if(nextProps.compete.benefitsData && !_.isEmpty(nextProps.compete.benefitsData) && this.state.createNewTabPending ){
            this.state.competeData.map(item=>{
                if(!item.benefitId){
                    nextProps.compete.benefitsData.res.map(benefitsItem=>{
                        if(item.groupId === nextProps.compete.benefitsData.body.groupId){
                            item.benefitId = benefitsItem.id,
                            item.wt = 0
                            this.setState({ createNewTabPending : false })
                        }
                    })
                }
            })
        }

        if(!nextProps.compete.createAbilityOfCompeteFetching  && nextProps.compete.createAbilityOfCompeteData && nextProps.compete.createAbilityOfCompeteData.statusCode === 200 && this.props.groupStepState === 4 && this.state.goNextStep) {
            this.props.groupStateNext();
        }
    }

    onChangeWT = (e, data) => {
        let value = e.target.value;

        let changedItem  =  this.state.competeData.find(r => r.groupId === data.groupId && r.benefitId === data.benefitId  && r.segmentId === data.segmentId);

        changedItem.wt = value
        this.setState({ weighting: this.state.weighting }
            // , () => this.weightingNumber()
        )
    }

    onChangeCriticalCapability = (e, data, index) => {
        let value = e.target.value;
        let getCriticalCapabilityParent = this.state.competeData.find(r => r.groupId === data.groupId && r.benefitId === data.benefitId && r.segmentId === data.segmentId);

        getCriticalCapabilityParent.criticalCapacity[index].text = value
        this.setState({ competeData : this.state.competeData})
    }

    accountCCWT = (data) => {
        let numbersArr = [];

        this.state.competeData.map((i,index )=> {
            if( data.groupId === i.groupId && data.segmentId === i.segmentId){
                i.criticalCapacity.map((count,index )=> {
                    return  numbersArr.push({
                                ccWt: count.ccWt,
                            // groupId: i.groupId,
                            //     segmentId: i.segmentId,
                            })
                })
            }

        })
        this.setState({ countCCWT : numbersArr })
    }

    onChangeCompetitors = (e) => {
        let value = e.target.value;
        for (let item of this.state.competitorsGroupsData) {
            if(item.groupId === value ) {
                item.important = true
            }else{
                item.important = false
            }
        }
    }

    onChangeRatingValue = (e, data, index) => {
        let value = e.target.value;
        let getItem = this.state.competeData.find(r => (r.groupId === data.groupId) && (r.segmentId === data.segmentId) && (r.benefitId === data.benefitId));
        getItem.criticalCapacity[index].rating = value;
        this.setState({ competeData: this.state.competeData}, this.totalScore());
    };

    onChangeCompetitorsRatingValue = (e, data, groupData, index) => {
        let value = e.target.value;
        let getItem = this.state.competeData.find(r => ( r.groupId === data.groupId) && ( r.segmentId === data.segmentId) && (r.benefitId === data.benefitId))
        //getItem.criticalCapacity[index].rating = value

        let isExist = getItem.criticalCapacity[index].competitors ? getItem.criticalCapacity[index].competitors.find(r => ( r.competitorId === groupData.competitorId))  : false;

        if(isExist) {
            isExist.rating = value
        } else{
            if(getItem.criticalCapacity[index].competitors){
                getItem.criticalCapacity[index].competitors.push({
                    competitorId: groupData.competitorId,
                    rating: value
                })
            } else{
                getItem.criticalCapacity[index].competitors = []
                getItem.criticalCapacity[index].competitors.push({
                    competitorId: groupData.competitorId,
                    rating: value
                })
            }

        }
        this.segmentTotalScore();

        this.setState({ competeData: this.state.competeData })
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    segmentTotalScore = () => {
        let competeData = [...this.state.competeData];
      for (let i of competeData) {
        let competitorTotal = [];
        i.criticalCapacity.map((critItem, index) => {
          let mappedData = i.competitorTotal && i.competitorTotal.length > 0 ? [...i.competitorTotal] : this.state.competitorsGroupsData;
          let dontCheckImportant = i.competitorTotal && i.competitorTotal.length > 0;
          mappedData.map((competitorsData, key) => {
            if (competitorsData.important) {
              let rateVal = critItem.competitors ? critItem.competitors.find(r => r.competitorId === competitorsData.competitorId) : { rating: "1" };
              let valScore = rateVal ? +critItem.ccWt * +rateVal.rating : +critItem.ccWt;
              competitorTotal.push({
                value: valScore,
                competitorId: competitorsData.competitorId,
                id: critItem.id
              });
            }
            if (dontCheckImportant) {
              let competitor = critItem.competitors ? critItem.competitors.find( r => r.competitorId === competitorsData.competitorId ) : null;
            //   if(critItem.id===competitorsData.id){
                let rateVal = competitor ? competitor.rating : "1";
                let valScore = rateVal ? +critItem.ccWt * +rateVal : +critItem.ccWt;
                competitorTotal.push({
                  value: valScore,
                  competitorId: competitorsData.competitorId,
                  id: critItem.id
                });
            //   }
            }
          });
        });
        let finalData = [];
        for (const x of competitorTotal) {
            let isUnique = _.find(finalData, { competitorId: x.competitorId, id: x.id })
            if (isUnique) {
                // console.log('isunique exist')
            }
            else finalData.push(x);
        }
        i.competitorTotal = finalData
      }
    };

    totalScore = () => {
        let totalCountScore  = 0;
        this.state.competeData.map((i,index )=> {
            let countScore  = 0;
            i.criticalCapacity.map((critItem,index )=> {
                let valScore = critItem.rating ? +critItem.ccWt * +critItem.rating : +critItem.ccWt;
                totalCountScore = +countScore + valScore;
                countScore = +countScore + valScore;
            })
            i.totalScore = countScore
        });
        this.setState({ totalScore: totalCountScore})
    };

    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-five arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-five arrow-step active-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-five arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                  <div className="row">
                    <div className="col-sm-12">
                      <h5>ABILITY TO COMPETE</h5>
                    </div>
                  </div>
                    {!this.props.compete.competeFetching && this.props.compete.competeFetched &&

                        <div className='row'>
                            <div className="col-md-12">
                                <div className='card'>
                                  <div className="card-header">
                                    <div className="col-md-8">
                                      <div className="criteria-title-box">
                                          <h5>Rate Benefits</h5>
                                          <span>Rate each Critical Capability against your competitors</span>
                                      </div>
                                  </div>
                                  </div>
                                  <div className='card-body'>
                                    { !this.state.createNewTabPending &&
                                      <WeightBenefitsTabs
                                          tabs={this.state.tabs}
                                          challengeStatementData={this.props.challengeStatement.getChallengeStatementData}
                                          benefitsData={this.state.benefitsData}
                                          competeData={this.state.competeData}
                                          onChangeWT={this.onChangeWT}
                                          onChangeCriticalCapability={this.onChangeCriticalCapability}
                                          countCCWT={this.state.countCCWT}
                                          competitorsGroupsData={this.state.competitorsGroupsData}
                                          onChangeCompetitors={this.onChangeCompetitors}
                                          onChangeRatingValue={this.onChangeRatingValue}
                                          onChangeCompetitorsRatingValue={this.onChangeCompetitorsRatingValue}
                                          benefits={this.props.benefits}
                                          tabStep={this.props.tabStep}
                                          onTabChange={this.props.onTabChange}
                                      />
                                    }
                                  </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='btn btn-success'

                                        onClick={() => this.onNextButtonClick()}
                                        >Next</div>
                                        {/* <a href="/toolkit" className='btn empty-btn default'>Back</a> */}
                                        <div className='btn empty-btn default' onClick={() => this.props.groupStateBack()}>Back</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    { this.props.compete.competeFetching &&
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className="card-body">
                                    {this.elementInfiniteLoad()}
                                </div>
                            </div>
                        </div>
                    }

                    { this.state.abilityToCompeteError &&
                        <AbilityToCompeteError
                            abilityToCompeteErrorModal={this.abilityToCompeteErrorModal}
                        />
                    }
                </div>
            </div>
        )
    }
}
export default (RateBenefits);



// WEBPACK FOOTER //
// ./src/components/AbilityToCompete/RateBenefits/RateBenefits.jsx